import React from "react";

function Download() {
    document.location.href =
      "https://play.google.com/store/apps/details?id=co.autojoomer.autojoomer";
    return (
        <>
            <div style={{margin: '20px', fontSize: '25px'}}>
                <center>Redirecting to Play Store...<br></br></center>
            </div>
            <div>
                <center><p>For any other problem while installing the APK, contact <font color="blue"><a href="mailto:Mail">vishallokare20bcs120@iiitkottayam.ac.in</a></font></p></center>
            </div>
        </>
    )
}

export default Download;